module.exports = __webpack_public_path__ + "static/before1-bdf0d69a4e5dcbc487573d342882ed2f.jpg";